// extracted by mini-css-extract-plugin
export default {"ShopCell":"ShopCell-styles__ShopCell__P1E0W","ShopCell__image":"ShopCell-styles__ShopCell__image__xKGRA"};